// Режим інтерфейсу: «простий» (дефолт — мінімум елементів, каталог у фокусі
// «китайські авто + електромобілі») і «повний» (усі фільтри та весь каталог).
// Живе в localStorage, атрибут data-mode на <html> ставить пре-пейнт в
// index.html (щоб не було спалаху) і цей сервіс при зміні.

export type UiMode = 'simple' | 'full';

const MODE_KEY = 'barter-ui-mode';

export function getUiMode(): UiMode {
  try {
    const stored = localStorage.getItem(MODE_KEY);
    if (stored === 'simple' || stored === 'full') return stored;
  } catch {}
  return 'simple';
}

export function applyUiMode(mode: UiMode) {
  document.documentElement.setAttribute('data-mode', mode);
}

export function saveUiMode(mode: UiMode) {
  try {
    localStorage.setItem(MODE_KEY, mode);
  } catch {}
  applyUiMode(mode);
}
